function Home(props) {
  return (
    <div className="welcomeMessage">
      <p>Welcome to Fermently, the fermentation project tracker!</p>
    </div>
  );
}

export default Home;